import _export from '../internals/export.js';
import mathExpm1 from '../internals/math-expm1.js';

var $ = _export;
var expm1 = mathExpm1; // `Math.expm1` method
// https://tc39.es/ecma262/#sec-math.expm1
// eslint-disable-next-line es/no-math-expm1 -- required for testing

$({
  target: 'Math',
  stat: true,
  forced: expm1 != Math.expm1
}, {
  expm1: expm1
});
